<div class="c-card">
    <div class="c-content u-no-p@up-to-md">
        <table-employee-training-program
                [(employees)]="vm.employees"
                [trainingProgramCode]="vm.trainingProgramCode"
                [pageSize]="vm.pageSize"
                [(currentPage)]="vm.currentPage"
                (currentPageChange)="vm.currentPageChanged($event)"></table-employee-training-program>
    </div>
    <div *ngIf="vm.employees && vm.employees?.length > vm.pageSize">
        <div class="o-grid u-ost-md u-osb-md">
            <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
                <list-pager [totalItems]="vm.employees?.length" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.currentPageChanged($event)"></list-pager>
            </div>
        </div>
    </div>
</div>
